define('views/pages/basket/basket',['require','views/base/view','views/dialog','views/pages/basket/basket-item-collection','lib/utils','text!templates/pages/basket/basket.ejs','text!templates/pages/basket/basket-title.ejs','views/demo-dialog'],function(require) {
    'use strict';

    var View = require('views/base/view'),
        Dialog = require('views/dialog'),
        BasketItemCollectionView = require('views/pages/basket/basket-item-collection'),
        utils = require('lib/utils'),
        template = require('text!templates/pages/basket/basket.ejs'),
        templateTitle = require('text!templates/pages/basket/basket-title.ejs'),
        DemoDialog = require('views/demo-dialog');

    var BasketTitle = View.extend({
        autoRender: true,
        template: templateTitle,
        listen: {
            'change:value model': 'render',
            'change:canBuy model': 'render'
        }
    });

    var BasketView = View.extend({
        template: template,
        className: 'basket-panel',
        listen: {
            'change:expanded model': 'updateExpanding'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
            this.delegate('click', '.panel-header', this.onClickExpand);
            this.delegate('click', '.btn-basket-clear', this.deleteClick);
            this.delegate('click', '.btn-basket-buy', this.buyClick);
            this.delegate('click', '.btn-basket-flash-order', this.flashOrder);
        },
        render: function() {
            View.prototype.render.apply(this, arguments);
            this.updateExpanding();
            this.subview('title', new BasketTitle({ model: this.model, el: this.$('.panel-header')}));
            this.subview('items', new BasketItemCollectionView({ model: this.model, collection: this.model.items, container: this.$('.panel-content') }));
        },
        onClickExpand: function() {
            this.model.set('expanded', !this.model.get('expanded'));
        },
        updateExpanding: function() {
            var value = this.model.get('expanded');
            this.$el[value ? 'addClass' : 'removeClass']('panel-expanded');

            if (value && !this.model.get('loading')) {
                this.model.load();
            }
        },
        deleteClick: function(){
            var _this = this;

            if (this.model.items.length === 0) { return; }

            Dialog.show('Очистка корзины', 'Вы действительно хотите очистить корзину?', Dialog.Buttons.YesNo)
                .attach(this)
                .submit(function() {
                    utils.delete('/basket/' + _this.model.get('tradeId'));
                    _this.model.collection.remove(_this.model);
                });
        },
        buyClick: function() {
            var _this = this;

            if (DemoDialog.isDemo()) { return DemoDialog.show(); }

            if (this.model.items.length === 0) { return; }

            Dialog
                .show('Покупка товара.', 'Вы действительно хотите совершить покупку?', Dialog.Buttons.YesNo)
                .attach(this)
                .submit(function() {
                    _this.model.buy(function(error) {
                        if (error) {
                            Dialog
                                .show('Не удалось выполнить покупку товара.', error, Dialog.Buttons.Close)
                                .attach(_this);
                        } else {
                            Dialog
                                .show('Покупка товара.', 'Заказ на сумму ' + utils.money(_this.model.get('value')) + ' ' + _this.model.get('viewCurrency') + ' по Т.П. ' + _this.model.get('tradeCode') + ' успешно оформлен.', Dialog.Buttons.Close)
                                .attach(_this);

                            _this.model.collection.remove(_this.model);
                        }
                    });
                });
        },
        flashOrder: function(){
            console.log('flashOrder', this.model.attributes);

            var _this = this;

            if (DemoDialog.isDemo()) { return DemoDialog.show(); }

            var tradeName = this.model.get('tradeCode');

            var requestData = {
                tradeId: this.model.get('tradeId')
            };

            if (this.model.get('items').length === 0) { return; }

            Dialog
                .show('Мгновенный заказ', 'Удаление заказа после отправки невозможно! Вы действительно хотите отправить заказ?', Dialog.Buttons.YesNo)
                .attach(this)
                .submit(function() {

                    utils.post('/api/request/flash-order-basket', {}, requestData).complete(function(xhr) {
                        var result = xhr.responseJSON || {};
                        var resultMap = {
                            'closed': 'Торговая сессия по Т.П. ' + tradeName + ' закрыта, по вопросам оформления заказа обратитесь к своему персональному менеджеру.',
                            'moneyLimit': 'Для оформления заказа находящегося в вашей корзине недостаточно денежных средств. По вопросу получения кредита, обратитесь к вашему персональному менеджеру.',
                            'error': 'Неизвестная ошибка.'
                        };
                        if (result.status === 'success' || result.status === 'partial') {
                            Dialog
                                .show('Мгновенный заказ', 'Ваш заказы по Т.П. ' + tradeName + ' сохранены в системе и отправлены на рассмотрение к поставщику. Отследить состояние заказа возможно в разделе "Заказы". Если потребуется, поставщик свяжется с вами по указанным контактным данным.', Dialog.Buttons.Close)
                                .attach(_this)
                                .cancel(function(){
                                    _this.model.collection.remove(_this.model);
                                });
                        } else {
                            Dialog
                                .show('Не удалось выполнить мгновенный заказ.', resultMap[result.status || 'error'] || resultMap.error, Dialog.Buttons.Close)
                                .attach(_this);
                        }
                    });
                });

        }
    });

    return BasketView;
});

